import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const CompanyHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
`;

export const CompanyHeaderFilterWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const CompanyHeaderFilterItemWrapper = styled.div`
  padding: 17px 16px;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.primaryMain};
    box-shadow: inset 0 -4px 0 ${theme.colors.primaryMain};
  `}
`;

export const CompanyHeaderFilterItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
`;
